import { AxiosResponse } from "axios";
import RouteService from "src/services/routeService";
import { ListResponse } from "src/types";

import HttpService from "./httpService";

export const getReleasedImages = async () => {
    const endpoint = await RouteService.getProductRoute();
    const url = endpoint + "builds/released";
    const response = await HttpService.get<string, AxiosResponse<ListResponse<API.ReleasedImage>>>(url);
    return response.data.list;
};
